'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Index = require('../components/Index');

var _Index2 = _interopRequireDefault(_Index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a specialized root Index component. It accepts
 * a specification of the root Element.
 * @param {object} defaultRoot - the defininition of the root of an Index sub tree.
 * @return {object} a Index root
 */
var createIndex = function createIndex(defaultRoot) {
  var CreateIndex = function CreateIndex(_ref) {
    var indexName = _ref.indexName,
        root = _ref.root,
        children = _ref.children;
    return _react2.default.createElement(
      _Index2.default,
      { indexName: indexName, root: root },
      children
    );
  };

  CreateIndex.propTypes = {
    indexName: _propTypes2.default.string.isRequired,
    root: _propTypes2.default.shape({
      Root: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]).isRequired,
      props: _propTypes2.default.object
    }),
    children: _propTypes2.default.node
  };

  CreateIndex.defaultProps = {
    root: defaultRoot
  };

  return CreateIndex;
};

exports.default = createIndex;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/core/createIndex.js
// module id = 954
// module chunks = 168707334958949